export const SequentialPrintLabelPolicy = ({
    labels: [
        { key: "SQP1", value: true },
        { key: "SQP2", value: true },
        { key: "SQP3", value: true },
        { key: "SQP4", value: true },
        { key: "SQP5", value: true },
        { key: "SQP6", value: true },
        { key: "SQP7", value: true },
        { key: "SQP8", value: true },
        { key: "SQP9", value: true },
        { key: "SQP10", value: true }]
})